// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__7uK9I","back":"Landing_back__x5i3C"};